/* import __COLOCATED_TEMPLATE__ from './content-side-drawer.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */
import type AiContentLibraryApi from 'embercom/lib/ai-content-library/list-api';
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Element: HTMLDivElement;
  Args: {
    contentType: number;
    contentId: number;
    listApi: AiContentLibraryApi;
    loadNextContent: (position: number) => void;
    loadContentForPosition: (position: number) => void;
    removeLastContent: () => void;
    onClose: () => void;
    reloadSummary: () => void;
    reloadPage: () => void;
  };
}

const ContentSideDrawer = templateOnlyComponent<Signature>();
export default ContentSideDrawer;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'ContentService::AiContentLibrary::ContentSideDrawer': typeof ContentSideDrawer;
  }
}
